import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { FormFeedback, FormGroup, Input } from 'reactstrap';

const EmergencyContacts = ({ formik, keyName, label, details, defaultValues }) => {
  const [contacts, setContacts] = useState([{ type: '', name: '', phoneNumber: '' }]);

  useEffect(() => {
    if (!isEmpty(details)) {
      const currentData = details[keyName];
      if (!isEmpty(currentData)) {
        setContacts(currentData);
      }
    }
  }, [details]);

  useEffect(() => {
    if (!isEmpty(defaultValues)) {
      setContacts(defaultValues);
    }
  }, [defaultValues]);

  const handleAdd = () => {
    const updated = [...contacts, { type: '', name: '', phoneNumber: '' }];
    setContacts(updated);
    formik.setFieldValue(keyName, updated);
  };

  const handleRemove = (index) => {
    const updated = contacts.filter((_, i) => i !== index);
    setContacts(updated);
    formik.setFieldValue(keyName, updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...contacts];
    updated[index][field] = value;
    setContacts(updated);
    formik.setFieldValue(keyName, updated);
  };

  return (
    <FormGroup>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h5 className="mb-0">{label}</h5>
        <button type="button" className="btn btn-md btn-outline-success mt-2" onClick={handleAdd}>
          <i className="bx bx-plus me-1" />
          Add
        </button>
      </div>

      {!isEmpty(contacts) &&
        contacts.map((contact, index) => (
          <div key={index} className="d-flex align-items-center mb-3 w-100">
            <h5 className="form-label me-3 mb-0">{index + 1}.</h5>

            {/* Type Select */}
            <Input
              type="select"
              value={contact.type}
              onChange={(e) => handleChange(index, 'type', e.target.value)}
              className="me-2"
              invalid={!!(formik.touched[keyName] && formik.errors[keyName]?.[index]?.type)}>
              <option value="">Select Type</option>
              <option value="Family">Family</option>
              <option value="Friend">Friend</option>
              <option value="Doctor">Doctor</option>
              <option value="Other">Other</option>
            </Input>

            {/* Name */}
            <Input
              type="text"
              value={contact.name}
              onChange={(e) => handleChange(index, 'name', e.target.value)}
              placeholder="Enter Name"
              className="ms-2 me-2"
              invalid={!!(formik.touched[keyName] && formik.errors[keyName]?.[index]?.name)}
            />

            {/* Phone Number */}
            <Input
              type="text"
              value={contact.phoneNumber}
              onChange={(e) => handleChange(index, 'phoneNumber', e.target.value)}
              placeholder="Enter Phone Number"
              className="ms-2 me-2"
              invalid={!!(formik.touched[keyName] && formik.errors[keyName]?.[index]?.phoneNumber)}
            />

            <button type="button" className="btn btn-outline-danger ms-2" onClick={() => handleRemove(index)}>
              <i className="bx bx-trash" />
            </button>
          </div>
        ))}

      <FormFeedback className="d-block">{formik?.errors?.[keyName]}</FormFeedback>
    </FormGroup>
  );
};

export default EmergencyContacts;
